import type { Timestamp } from '@bufbuild/protobuf/wkt';
import { convertToDate } from 'gpcore-apikit/lib/date';
import useDateFormat from 'gpcore-uikit/composables/useDateFormat';

export default () => {
  const format = useDateFormat();

  const formatDate = (date: Date | number | bigint | Timestamp) => {
    const d = convertToDate(date);
    return format(d, 'short');
  };

  return formatDate;
};
